import { AxiosPromise } from 'axios';
import Http from '../../shared/http';
import {
  API_PATH_DIAMETER,
  Diameter,
} from './diameter.types';
import { ServerResponse } from '../types';

const http = Http.getHttp();

// eslint-disable-next-line import/prefer-default-export
export function getDiameters(
  deliveryFunctionId: string,
): AxiosPromise<ServerResponse<Diameter>> {
  return http.get(`${API_PATH_DIAMETER}/${deliveryFunctionId}`);
}
